/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 18/09/2023.
 */
import React from 'react'

type Props = {
  label: string
  title: string
  style?: React.CSSProperties
  className?: string
  type?: string
  comp?: React.ReactNode | React.ReactNode[]
  capitalizeText?: boolean
  truncate?: boolean
}

export const ListItemContent = ({
  label,
  title,
  style,
  className,
  type,
  comp = null,
  capitalizeText = false,
  truncate = false,
}: Props) => {
  const cl = className ? className : 'ps-2 my-3 '

  return (
    <div className={cl} style={style}>
      <p className="p-mini opacity-50 fw-bold" style={{ letterSpacing: 0.2 }}>
        {label.toUpperCase()}
      </p>

      {!comp && label && type === 'danger' ? (
        <p
          className={`mb-1 fw-bold text-danger text-truncate ${capitalizeText ? 'text-capitalize' : ''} `}
          style={{ letterSpacing: 0.2, fontSize: 16 }}
        >
          {capitalizeText ? title?.toLowerCase() : title}
        </p>
      ) : null}

      {!comp && label && type !== 'danger' ? (
        <p
          className={`mb-1 fw-bold text-truncate ${capitalizeText ? 'text-capitalize' : ''} `}
          style={{ fontSize: 16, letterSpacing: 0.2, maxWidth: '88%' }}
        >
          {capitalizeText ? title?.toLowerCase() : title}
        </p>
      ) : null}

      {comp ? <>{comp}</> : null}
    </div>
  )
}
